export default {
    breadcrumbs: {
        my_companies: 'Мои компании',
    },
    buttons: {
        create_company: '+ Создать компанию',
    },
    card: {
        pib: 'ПИН',
    },
    no_companies: 'У вас нет добавленных компаний',
    no_peronal_info: 'Пожалуйста, укажите имя, фамилию и номер телефона',
}
